import { PickersShortcutsItem } from '@mui/x-date-pickers';
import { CalendarShortcut, calendarShortcutToValueMap } from '../../../../../components/DatePicker/Calendar';
import {
  nextQuarterEnd,
  nextYearEnd,
  previousQuarterEnd,
  previousYearEnd,
} from '../../../../../util/date-utilts';

/**
 * The as-of picker's shortcut rail. Prev and Next step from `stepFrom`, the date the popup is
 * showing, so repeated clicks walk period by period: quarters land on quarter ends, years on
 * 31 December, and nothing is bounded by today. Today is the one absolute.
 */
export function portfolioDateShortcuts(stepFrom: Date): PickersShortcutsItem<Date | null>[] {
  return [
    { id: 'prev-quarter', label: CalendarShortcut.prevQuarter, getValue: () => previousQuarterEnd(stepFrom) },
    { id: 'next-quarter', label: 'Next Quarter', getValue: () => nextQuarterEnd(stepFrom) },
    { id: 'prev-year', label: CalendarShortcut.prevYear, getValue: () => previousYearEnd(stepFrom) },
    { id: 'next-year', label: 'Next Year', getValue: () => nextYearEnd(stepFrom) },
    {
      id: 'today',
      label: CalendarShortcut.today,
      getValue: calendarShortcutToValueMap[CalendarShortcut.today],
    },
  ];
}
